
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crop-image/editor",
      function () {
        return require("private-next-pages/crop-image/editor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crop-image/editor"])
      });
    }
  